module.exports = __webpack_public_path__ + "static/media/linkedin.d14b481e.svg";